import React, { useRef, useState } from "react";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { cargarArchivoFormSchema } from "../../common/validation-schemas";
import { cargarArchivoAction } from '../../store/actions/carga-masiva-action';
import { cargasPreviasAction } from '../../store/actions/carga-masiva-action';
import { Auth } from 'recupero-comunes';

const CargarArchivo = () => {

    const { rutUsuario, rutOrganizacion, paisOrganizacion } = Auth.currentUser();
    const user = { "rutUsrCreacion": rutUsuario, "idOrganizacion": rutOrganizacion, "codPais": paisOrganizacion };

    const fileRef = useRef();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    
    // El hook useFormik (formik) permite definir las propiedades del formulario. Devuelve estados y funciones de ayuda.
    const formik = useFormik({
        
        initialValues: { file: null }, // Valores iniciales para cada input del formulario
        validationSchema: cargarArchivoFormSchema, // Esquema de validación de Yup para el formulario.
        onSubmit: (values) => { // Función ejecutada al invocar formik.handleSubmit()
          

            // Iniciar 'Cargando...' en botón 'Cargar Archivo'
            setLoading(true);

            // Transformar archivo en Base64
            getBase64(values.file).then((base64data) => {
                
                // Data requerida para cargar archivo. Utilizamos sintaxis spread (...) para concatenar valores de user y datos de archivo. 
                
                let data = { ...user, "filename": values.file.name, "mimetype": values.file.type, "base64data": base64data, "modulo": "cms" };

                // Invocar a la acción que realiza la carga del archivo
                dispatch(cargarArchivoAction(data)).then(() => {

                    // Reseter el formulario
                    handleReset();

                    // Obtener las cargas previas.
                    let query = btoa(JSON.stringify({ "idOrganizacion": rutOrganizacion, "tipoCarga":"108007" }));
                    dispatch(cargasPreviasAction(query));

                }).catch((error) => {
                    setLoading(false);
                    console.error(error);
                    alert(error.message);
                });
            })
            .catch((error) => {
                setLoading(false);
                console.error(error);
                alert(error.message);
            });
        }
    });

    const handleReset = () => {
        fileRef.current.value = "";
        formik.resetForm();
        setLoading(false);
    }

    return (
        <div>
            <Form noValidate onSubmit={formik.handleSubmit} className="mt-4">

                <Form.Group className="position-relative mb-4">
                    <Form.Control ref={fileRef} type="file" name="file"
                        onChange={event => { formik.setFieldValue("file", event.currentTarget.files[0]); }} onBlur={formik.handleBlur}
                        isInvalid={!!formik.errors.file}
                        isValid={formik.touched.file && !formik.errors.file}
                    />
                    <Form.Text className="text-muted">Tamaño máximo del archivo: 10MB</Form.Text>
                    <Form.Control.Feedback type="invalid"> {formik.errors.file} </Form.Control.Feedback>
                </Form.Group>

                <hr className="mt-4" />

                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <Button className="me-md-2" variant="warning" type="button" onClick={() => { handleReset() }}>Limpiar</Button>
                    <Button variant="danger" type="submit" disabled={loading}>
                        { loading ?
                        <div><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Cargando...</div>
                        : "Cargar Archivo" }
                    </Button>
                </div>

            </Form>
        </div>
    )
}

export default CargarArchivo;

const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
    });
};